import React from 'react';
import { DateField, DateFieldProps, useRecordContext } from 'react-admin';
import get from 'lodash/get';
import moment from 'moment';

// Theme colours rather than named ones: plain "blue" all but vanished on the dark theme.
const AlertDateField = (props: DateFieldProps) => {
  let color = 'success.main';
  const record = useRecordContext(props);
  if (!record) {
    return null;
  }
  const value = get(record, props.source!);
  if (value != null || value !== '') {
    const date = value instanceof Date ? value : new Date(value);
    const diffDays = moment(date).diff(moment(), 'days');
    switch (true) {
      case diffDays < 1:
        color = 'error.main';
        break;
      case diffDays < 3:
        color = 'warning.main';
        break;
      case diffDays < 7:
        color = 'info.main';
        break;
      default:
        color = 'success.main';
        break;
    }
  }

  return <DateField {...props} sx={{ color, fontWeight: 'bold' }} />;
};

export default AlertDateField;
